import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";
import toast from "react-hot-toast";

function AddPermission() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    module_name: "",
    permission_key: "",
    permission_name: "",
  });

  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      await API.post(
        "/permissions",
        form
      );

      toast.success(
        "Permission added successfully"
      );

      navigate(
        "/admin/permissions"
      );

    } catch (err) {

      console.log(err);

      toast.error(
        err.response?.data?.message ||
        "Failed to add permission"
      );

    } finally {
      setLoading(false);
    }
  };

  return (
    <div>

      <div className="mb-8">

        <h1
          className="
          text-4xl
          font-bold
        "
        >
          Add Permission
        </h1>

        <p className="text-gray-400 mt-2">
          Create a new permission
        </p>

      </div>

      <form
        onSubmit={submit}
        className="
        bg-[#111]
        rounded-2xl
        p-8
        max-w-3xl
        border
        border-yellow-500/20
      "
      >

        <div className="mb-6">

          <label
            className="
            block
            mb-2
            font-semibold
          "
          >
            Module Name
          </label>

          <input
            type="text"
            required
            placeholder="Product"
            value={form.module_name}
            onChange={(e) =>
              setForm({
                ...form,
                module_name:
                  e.target.value,
              })
            }
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            focus:border-yellow-500
            outline-none
          "
          />

        </div>

        <div className="mb-6">

          <label
            className="
            block
            mb-2
            font-semibold
          "
          >
            Permission Key
          </label>

          <input
            type="text"
            required
            placeholder="product.edit"
            value={form.permission_key}
            onChange={(e) =>
              setForm({
                ...form,
                permission_key:
                  e.target.value,
              })
            }
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            focus:border-yellow-500
            outline-none
          "
          />

          <p
            className="
            text-xs
            text-gray-500
            mt-2
          "
          >
            Example:
            product.view,
            product.add,
            product.edit,
            product.delete
          </p>

        </div>

        <div className="mb-8">

          <label
            className="
            block
            mb-2
            font-semibold
          "
          >
            Permission Name
          </label>

          <input
            type="text"
            required
            placeholder="Edit Product"
            value={form.permission_name}
            onChange={(e) =>
              setForm({
                ...form,
                permission_name:
                  e.target.value,
              })
            }
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            focus:border-yellow-500
            outline-none
          "
          />

        </div>

        <div
          className="
          flex
          gap-4
        "
        >

          <button
            disabled={loading}
            type="submit"
            className="
            bg-yellow-500
            text-black
            px-8
            py-3
            rounded-xl
            font-semibold
            hover:bg-yellow-400
            disabled:opacity-50
          "
          >
            {loading
              ? "Saving..."
              : "Save Permission"}
          </button>

          <button
            type="button"
            onClick={() =>
              navigate(
                "/admin/permissions"
              )
            }
            className="
            bg-gray-700
            hover:bg-gray-600
            px-8
            py-3
            rounded-xl
          "
          >
            Cancel
          </button>

        </div>

      </form>

    </div>
  );
}

export default AddPermission;